import analytics from 'utils/analytics';
import SearchConfig from '@sun-chemical/system-config/search-config';
import * as types from './mutation-types';

export default {
  setUrlFilters({ commit }, filters) {
    commit(types.SET_URL_FILTERS, filters);
  },
  setActiveIndustry({ dispatch, getters }, industry) {
    // Set the active industry, also resets all filters except for the search term
    const newUrlFilters = { i: industry };

    if (getters.urlFilters.hasOwnProperty('q') && getters.urlFilters.q) {
      newUrlFilters.q = getters.urlFilters.q;
    }

    dispatch('setUrlFilters', newUrlFilters);
  },
  setActiveDropDownFilter({ commit }, filter) {
    commit(types.SET_ACTIVE_DROPDOWN_FILTER, filter);
  },
  setSearchTerm({ commit, getters }, term) {
    // Do nothing if an empty search term is passed and also no one was set before
    if (getters.searchTerm === undefined && term === '') return;

    // Only commit if the term changed
    if (getters.searchTerm !== term) {
      commit(types.SET_SEARCH_TERM, term);
    }
  },
  resetFilters({ getters, dispatch }) {
    const reset = {};

    if (getters.urlFilters && getters.urlFilters.tab) {
      reset.tab = getters.urlFilters.tab;
    }

    dispatch('setUrlFilters', reset);
  },
  setLoadingState({ commit }, loadingState) {
    commit(types.SET_LOADING_STATE, loadingState);
  },
  showMobileFilterBar({ commit }) {
    commit(types.SET_MOBILE_FILTER_BAR_VISIBILITY, true);
    document.getElementsByTagName('body')[0].classList.add('ce-mobileFilterBarVisible');
  },
  hideMobileFilterBar({ commit }) {
    commit(types.SET_MOBILE_FILTER_BAR_VISIBILITY, false);
    document.getElementsByTagName('body')[0].classList.remove('ce-mobileFilterBarVisible');
  },
  toggleMobileFilterBar({ dispatch, state }) {
    if (state.mobileFilterBarVisible) {
      dispatch('hideMobileFilterBar');
    } else {
      dispatch('showMobileFilterBar');
    }
  },
  trackSearch({ getters, rootGetters }) {
    if (rootGetters['generic/functionalCookiesEnabled']) {
      analytics.trackSearch(
        getters.urlFilters[SearchConfig.getMap().search_term.param],
        getters.filtersAsSearchCategory,
        getters.resultsTotal
      );
    }
  }
};
